module.exports = __webpack_public_path__ + "img/Halts-Interchanges.fa21e0c3.png";